import React from 'react';
import CreatableSelect from 'react-select/creatable';
import { FlexContainer } from '../styles';
import { IOption } from '../interfaces';
import { MenuPlacement } from 'react-select';

interface ISelectProps {
  options: IOption[] | [];
  placeholder?: string;
  selectedOptions: IOption[];
  onChange?: (newValues: IOption[]) => void;
  onSingleChange?: (newValue: IOption) => void;
  isMulti?: boolean;
  error?: boolean;
  className?: string;
  classPrefix?: string;
  isClearable?: boolean;
  errorMessage?: string;
  allowCreateOption?: boolean;
  menuPlacement?: MenuPlacement;
}

export const SelectCreateable: React.FC<ISelectProps> = ({
  isClearable = true,
  allowCreateOption = true,
  menuPlacement = 'auto',
  ...props
}) => {
  return (
    <FlexContainer fxLayout="column" size={0}>
      <CreatableSelect
        className={`${props.className} ${props.error ? 'error-border' : ''}`}
        isMulti={props.isMulti}
        onChange={(newValue: any) => {
          props.isMulti
            ? props.onChange && props.onChange(newValue)
            : props.onSingleChange && props.onSingleChange(newValue);
        }}
        value={props.selectedOptions}
        options={props.options}
        classNamePrefix={props.classPrefix}
        placeholder={props.placeholder}
        isClearable={isClearable}
        isValidNewOption={(inputValue: string, value: any, options: any) => {
          if (options.find(x => x.label?.toLowerCase().trim() === inputValue?.toLowerCase().trim())) {
            return false;
          }
          value;
          return allowCreateOption && inputValue ? true : false;
        }}
        // menuIsOpen={true} //uncomment this to open the dropdown
        menuPlacement={menuPlacement}
      />
      {props.errorMessage && <p className="error-message">{props.errorMessage}</p>}
    </FlexContainer>
  );
};

export default SelectCreateable;
